import React, { useRef, useState, useEffect } from 'react';
import { Input, notification, Select, Button, Typography } from 'antd';
import { UserOutlined, DownOutlined } from '@ant-design/icons';
import '../jira/IssueCardCustomization/IssueCard.css';
import { wrap } from 'highcharts';
const { Text } = Typography;
function IssueCard(props) {
  const isApphome = true;
  const issueData = props.issueData && props.issueData.slice(0, 6);
  const [issues, setIssues] = useState([]);
  const [showAtrributesMore, setShowAttributesMore] = useState(false);
  const [showButtonActionsMore, setShowButtonActionsMore] = useState(false);
  const isApphomePreview = false;
  useEffect(() => {
    if (
      props.selectedAttributesDetailed &&
      props.selectedAttributesDetailed.length > 5
    ) {
      setShowAttributesMore(true);
    } else {
      setShowAttributesMore(false);
    }
  }, [props.selectedAttributesDetailed]);
  useEffect(() => {
    if (props.buttonActions && props.buttonActions.length > 5) {
      setShowButtonActionsMore(true);
    } else {
      setShowButtonActionsMore(false);
    }
  }, [props.buttonActions]);

  useEffect(() => {
    setIssues(props.issueData && props.issueData.slice(0, 1));
  }, [props.issueData]);

  const truncateString = (data, truncateLength = 30) => {
    if (data.length > truncateLength)
      data = data.slice(0, truncateLength) + '...';
    return data;
  };
  const buttonActions = props.buttonActions;
  let headerAttribute = {
    name: 'Status',
    id: '10007',
    key: 'status',
  };
  const viewType = props.viewType;
  const isRealTimeNotification = props.isRealTimeNotification;
  const showSyncingText =
    props.tabKey === 'threadsync' &&
    props.showFooterMessage &&
    viewType !== 'channel'
      ? true
      : false;

  const notificationDisplayFormat = props.notificationDisplayFormat;
  let hideButtonActions =
    props.tabKey === 'notification' &&
    notificationDisplayFormat !== 'detailed' &&
    viewType === 'channel'
      ? true
      : false;
  if (
    buttonActions &&
    buttonActions.length <= 1 &&
    props.fieldsSelectedDetailed &&
    props.fieldsSelectedDetailed.length == 0 &&
    !props.showAllDropdownActions
  ) {
    hideButtonActions = true;
  } else if (!props.fieldSelectedCompact) {
    hideButtonActions = true;
  }
  const hideAttributes =
    props.tabKey === 'notification' &&
    notificationDisplayFormat === 'compact' &&
    viewType === 'channel'
      ? true
      : false;

  return (
    <div
      style={{
        padding: isApphomePreview ? 0 : 16,
        width: '100%',
      }}
    >
      <div className='issue-card'>
        <>
          {/* {!isApphomePreview && (
            <div className='issue-card-left app-avatar'>
              <span>
                <img
                  src='https://app.troopr.io/logo/square.png'
                  alt='logo'
                  id='app-logo-card'
                />
              </span>
            </div>
          )} */}
          <div
            className='issue-card-right card-containts'
            style={{ marginLeft: '0px' }}
          >
            {/* {!isApphomePreview && (
              <div
                className='message-header'
                style={{
                  marginTop:
                    props.tabKey === 'notification' &&
                    viewType === 'channel' &&
                    props.notificationDisplayFormat === 'compact'
                      ? '10px'
                      : '0px',
                }}>
                <div className='message-author'>Troopr Assistant</div>
                <div className='time-stamp'>11:30 AM</div>
              </div>
            )} */}

            {issues &&
              issues.map((issue) => {
                return (
                  <div className='message-blocks'>
                    {props.tabKey === 'notification' &&
                    viewType === 'channel' &&
                    props.notificationDisplayFormat === 'compact' &&
                    !isRealTimeNotification ? (
                      ''
                    ) : (
                      <div
                        style={{ display: 'flex', alignItems: 'center' }}
                        className='issue-key-header'
                      >
                        <b className='issue-key'>{issue.key || 'ST'}-1</b>
                        <code className='attr-1 status'>
                          {props.fieldSelectedCompact
                            ? props.fieldSelectedCompact.key
                            : headerAttribute.name}{' '}
                          {issue.fields[
                            `${
                              props.fieldSelectedCompact
                                ? props.fieldSelectedCompact.key.toLowerCase()
                                : headerAttribute.name.toLowerCase()
                            }`
                          ] &&
                            (issue.fields[
                              `${
                                props.fieldSelectedCompact
                                  ? props.fieldSelectedCompact.key.toLowerCase()
                                  : headerAttribute.name.toLowerCase()
                              }`
                            ].name ||
                              issue.fields[
                                `${
                                  props.fieldSelectedCompact
                                    ? props.fieldSelectedCompact.key.toLowerCase()
                                    : headerAttribute.name.toLowerCase()
                                }`
                              ].displayName)}
                        </code>
                        <b className='summary'>{issue.fields['summary']}</b>{' '}
                        &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;&nbsp; &nbsp;
                        &nbsp;
                        {hideButtonActions && (
                          <Button
                            style={{
                              width: '36px',
                              height: '16px',
                              fontSize: '8px',
                              borderRadius: '2px',
                              padding: '1px 8px',
                            }}
                          >
                            {props.buttonActions &&
                            props.buttonActions[0] &&
                            props.buttonActions[0].name
                              ? props.buttonActions[0].name
                              : 'View'}
                          </Button>
                        )}
                      </div>
                    )}
                    {props.showDescription &&
                      props.tabKey !== 'notification' && (
                        <div className='message-description'>
                          <div className='description-text'>
                            {props.tabKey === 'notification'
                              ? 'The description text will be shown here'
                              : 'The description text will be shown here below the issue summary. This text can be at most 300 characters after which it will be truncated.'}
                          </div>
                        </div>
                      )}
                    {props.isCompact && (
                      <div
                        className='issue-key-header'
                        style={{ marginTop: '10px' }}
                      >
                        <b className='issue-key'>
                          {props.projectKey || 'ST'}-2
                        </b>
                        <code className='attr-1 status'>
                          {props.selectedField
                            ? props.selectedField.name
                            : headerAttribute.name}{' '}
                          {issue.status}
                        </code>
                        <b className='summary'>{issue.summary}</b>
                      </div>
                    )}

                    {!props.isCompact && (
                      <>
                        {props.fieldsSelectedDetailed &&
                          props.fieldsSelectedDetailed.length > 0 && (
                            <div
                              // ref={scrollRef}
                              style={{
                                maxHeight: '125px',
                                overflow: 'hidden',
                              }}
                            >
                              {!hideAttributes && (
                                <div
                                  className={`${
                                    (props.tabKey === 'notification' &&
                                      !isRealTimeNotification) ||
                                    props.attributesAllignment === 'horizontal'
                                      ? 'attributeHorizontal'
                                      : 'attribute-list slack-blockquote'
                                  }`}
                                  style={{
                                    display: 'flex',
                                    flexDirection: `${
                                      (props.tabKey === 'notification' &&
                                        !isRealTimeNotification) ||
                                      props.attributesAllignment ===
                                        'horizontal'
                                        ? 'row'
                                        : 'column'
                                    }`,
                                    // margin: '0.3rem',
                                  }}
                                >
                                  {props.fieldsSelectedDetailed &&
                                    props.fieldsSelectedDetailed
                                      .slice(0, 5)
                                      .map((attribute, index) => {
                                        if (!(attribute && attribute.name)) {
                                          return <></>;
                                        }
                                        return (
                                          <div
                                            key={attribute.name}
                                            className='attribute'
                                          >
                                            <div className='attribute-name'>
                                              {attribute.name}
                                            </div>
                                            <div className='attribute-name'>
                                              :&nbsp;
                                            </div>
                                            <div className='attribute-value'>
                                              {issue.fields[
                                                attribute.name.toLowerCase()
                                              ] &&
                                                (issue.fields[
                                                  attribute.name.toLowerCase()
                                                ].name ||
                                                  issue.fields[
                                                    attribute.name.toLowerCase()
                                                  ].displayName)}
                                            </div>
                                          </div>
                                        );
                                      })}
                                  {showAtrributesMore && (
                                    <div>
                                      <a to='/'>
                                        [... +
                                        {props.fieldsSelectedDetailed.length -
                                          5}{' '}
                                        more{' '}
                                        {props.fieldsSelectedDetailed.length -
                                          5 ===
                                        1
                                          ? 'attribute'
                                          : 'attributes'}
                                        ]
                                      </a>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          )}

                        {!hideButtonActions && (
                          <div
                            style={{
                              width: `${props.tabKey === 'notification'}`,
                              marginBottom: 10,
                            }}
                            className='buttonActions'
                          >
                            {buttonActions &&
                              buttonActions
                                .slice(0, 5)
                                .filter((item) => item.name)
                                .map((button, index) => {
                                  return (
                                    <div
                                      key={index}
                                      style={{
                                        padding: '4px 8px',
                                        border: '1px solid #ccc',
                                        // background: '#fff',
                                        boxShadow:
                                          '0px 2px 0px rgba(0, 0, 0, 0.016)',
                                        height: '24px',
                                        textAlign: 'center',
                                        borderRadius: 2,
                                        fontWeight: 400,
                                        lineHeight: '156.5%',
                                        whiteSpace: 'nowrap',
                                        fontSize: '10px',
                                      }}
                                    >
                                      {truncateString(button.name, 15)}
                                    </div>
                                  );
                                })}

                            {props.showAllDropdownActions && (
                              <div
                                style={{
                                  border: '1px solid #ccc',
                                  borderRadius: 2,
                                  boxShadow: '0px 2px 0px rgba(0, 0, 0, 0.016)',
                                  padding: '4px 8px',
                                  width: 110,
                                  height: 24,
                                  textAlign: 'center',
                                  fontWeight: 400,
                                  fontSize: '10px',
                                  lineHeight: '15.65px',
                                }}
                                disabled
                              >
                                Select an action <DownOutlined />
                              </div>
                            )}
                            {buttonActions && buttonActions.length > 5 && (
                              <a style={{ alignSelf: 'center' }} to='#'>
                                [... +{props.buttonActions.length - 5} more{' '}
                                {props.buttonActions.length - 5 === 1
                                  ? 'action'
                                  : 'actions'}
                                ]
                              </a>
                            )}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                );
              })}
          </div>

          {props.isCompact && (
            <div className='issue-key-header' style={{ marginTop: '10px' }}>
              <b className='issue-key'>{props.projectKey || 'ST'}-2</b>
              <code className='attr-1 status'>
                {props.selectedField
                  ? props.selectedField.name
                  : headerAttribute.name}{' '}
                value
              </code>
              <b className='summary'>Summary Text Goes Here</b>
            </div>
          )}
        </>
      </div>
    </div>
  );
}

export default IssueCard;
